import {
	BulkUpdateSingleSubscriptionUsersRequest,
	User,
	UserOperationResult,
} from '@Types/user.types';
import {
	PaginatedUsers,
	UpdateRoleParams,
	UserParams,
} from '@Types/users.types';

import { RegisteredApplications } from '@innovyze/stylovyze';
import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';

export const getUsers = createAction<UserParams>(
	addNamespace('users/getUsers'),
);
export const getUsersResolved = createAction<PaginatedUsers>(
	addNamespace('users/getUsers/resolved'),
);
export const getUsersRejected = createAction(
	addNamespace('users/getUsers/rejected'),
);

export const getSingleUser = createAction<string>(
	addNamespace('users/getSingleUser'),
);
export const getSingleUserResolved = createAction<User>(
	addNamespace('users/getSingleUser/resolved'),
);
export const getSingleUserRejected = createAction(
	addNamespace('users/getSingleUser/rejected'),
);

export const deleteUser = createAction<string>(
	addNamespace('users/deleteUser'),
);
export const deleteUserResolved = createAction<boolean>(
	addNamespace('users/deleteUser/resolved'),
);
export const deleteUserRejected = createAction(
	addNamespace('users/deleteUser/rejected'),
);

export const updateUser = createAction<User>(addNamespace('users/updateUser'));

export const clearUserById = createAction(addNamespace('users/clearUserById'));

export const updateUserResolved = createAction(
	addNamespace('users/updateUser/resolved'),
);

export const updateUserRejected = createAction(
	addNamespace('users/updateUser/rejected'),
);

export const updateRole = createAction<UpdateRoleParams>(
	addNamespace('users/updateRole'),
);
export const updateRoleResolved = createAction<boolean>(
	addNamespace('users/updateRole/resolved'),
);
export const updateRoleRejected = createAction(
	addNamespace('users/updateRole/rejected'),
);

export const createUser = createAction<{
	user: User;
	redirectTo?: string;
	applicationName?: RegisteredApplications;
}>(addNamespace('users/createUser'));
export const createUserResolved = createAction<boolean>(
	addNamespace('users/createUser/resolved'),
);
export const createUserRejected = createAction(
	addNamespace('users/createUser/rejected'),
);
export const createUserReset = createAction(
	addNamespace('users/createUser/reset'),
);

export const bulkUpdateSingleSubscriptionUsers =
	createAction<BulkUpdateSingleSubscriptionUsersRequest>(
		addNamespace('users/bulkUpdateSingleSubscriptionUsers/update'),
	);

export const bulkUpdateSingleSubscriptionUsersResolved = createAction<
	UserOperationResult[] | undefined
>(addNamespace('users/bulkUpdateSingleSubscriptionUsers/resolved'));

export const bulkUpdateSingleSubscriptionUsersRejected = createAction<
	UserOperationResult[] | undefined
>(addNamespace('users/bulkUpdateSingleSubscriptionUsers/rejected'));
